import { useTranslation } from 'react-i18next'
import InputFormikAutocomplete from '@/views/components/input-formik-autocomplete/index.component'
import { CountryCodesEnum } from '@/enums'

export const CountryPersonalInfo = () => {
  const { t } = useTranslation()

  return (
    <InputFormikAutocomplete
      name="country"
      label={t('labels.country')}
      options={Object.values(CountryCodesEnum) || []}
      getOptionLabel={(option) => t(`countries.${option}`)}
    />
  )
}
